// import './App.css';
import { useState, useEffect, } from "react";
import ScrollToTop from './ScrollToTop.js';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useAuth } from './AuthContext';
import { IdProvider } from "./Components/Home/IdContext.js";
import ChatbotUI from "./Components/Chatbot/Chatbotui.js";
import { useParams } from "react-router-dom";
import PreJoin1v1 from "./Components/PreJoin1v1.js";
import PreJoinScreen from "./Components/PreJoinScreen.js";
import Home from './Components/Home/Home';
import AboutUs from './Components/Footer/AboutUs.js';
import Careers from './Components/Footer/Careers/Careers.js';
import Internship from './Components/Footer/Careers/Internship.js';
import Jobs from './Components/Footer/Careers/Jobs.js';
import Faqs from './Components/Footer/Faqs.js';
import TermsAndConditions from './Components/Footer/TermsAndConditions.js';
import AiContent from './Components/Home/AiContent.js';
import Recommendations from './Components/Diwakar_dev/Recommendations/Recommendations.js';
import UserProfile from './Components/UserProfile/UserProfile.js';
import Documentation from './Components/Diwakar_dev/Documentation.js';
import Demo from './Components/Diwakar_dev/Demo.js';
import Login from './Components/Login/Login.js';
import SignUp from "./Components/SignUp/SignUp";
import CreatePost from './Components/Post/CreatePost.js';
import Platform from './Components/Platform/Platform.js';
import Posted from './Components/Post/Posted.js';
import FullSection from './Components/Post/FullSection.js';
import PostTabDetails from './Components/Post/PostTabDetails.js';
import MyPostTabDetails from "./Components/Post/MyPostTabDetails.js";
import MyBookingTabDetails from "./Components/Post/MyBookingTabDetails.js";
import MyPosts from './Components/Post/MyPosts.js';
import CreateSubscriptions from './Components/Admin/CreateSubscriptions.js';
import CreateSections from './Components/Admin/CreateSections.js';
import AddSubSections from './Components/Admin/AddSections.js';
import Subscriptions from './Components/Platform/Subscriptions.js';
import Categories from './Components/Platform/Categories.js';
import AdminPortal from './Components/Admin/AdminPortal.js';
import SubscribeDetails from './Components/Platform/SubscribeDetails.js';
import JitsiMeet from './Components/Diwakar_dev/JitsiMeet.js';
import { GoogleLogin } from '@react-oauth/google'; // Import Google Login
import Header from './Components/Header/Header.js';
import Header1 from './Components/Header/Header1.js';
import Header2 from './Components/Header/Header2.js';
import Header3 from './Components/Header/Header3.js';
import Payments from './Components/Payments/Payments.js';
import SubCategoriesPosts from './Components/Post/SubCategoriesPosts.js';
import MyBookings from './Components/Platform/MyBookings.js';
import FeedbackForm from './Components/Feedback/FeedbackForm.js';
import GuideFeedbackForm from './Components/Feedback/GuideFeedbackForm.js';
import AISync from './Components/AI Sync/AISync.js';
import GenerateMeetingLinkButton from './Components/GoogleMeet/GenerateMeetingLinkButton.js';
import CustomerSupport from './Components/CustomerSupport/CustomerSupport.js';
import Verification from './Components/Verification/Verification.js';
import AdminVerification from './Components/Admin/AdminVerification.js';
import DatabaseSizeDisplay from './Components/DataAnalytics/DatabaseSizeDisplay.js';
import RecommendationSetup from './Components/Recommendations/RecommendationSetup.js';
import PostRecommendations from './Components/Recommendations/PostRecommendations.js';
import PasswordReset from './Components/Login/PasswordReset.js';
import AdminLogin from './Components/Admin/AdminLogin.js';
import SubscriptionsPayment from './Components/Payments/SubscriptionsPayment.js';
import CustomerQueriesResolve from './Components/Admin/CustomerQueriesResolve.js';
import InterviewPanel from './Components/Admin/InterviewPanel.js';
import Community from './Components/Community/community.js';
import { CssBaseline, Box, Container } from '@mui/material';
import AdminFaqs from "./Components/Admin/AdminFaqs.js";
import AdminCareers from "./Components/Admin/AdminCareers.js";
import AdminContactUs from "./Components/Admin/AdminContactUs.js";
import CreateSpecializedFields from "./Components/Admin/CreateSpecializedFields.js";
import UserPayments from "./Components/Admin/UserPayments.js";
import MeetingInstructions from "./Components/Platform/MeetingInstructions.js";
import AdminCreateAccounts from "./Components/Admin/AdminCreateAccounts.js";
import AdminUpdateAccounts from "./Components/Admin/AdminUpdateAccounts.js";
import RefundsAndCancellationsPolicy from "./Components/Legal/RefundsAndCancellationsPolicy.js";
import PrivacyPolicy from "./Components/Legal/PrivacyPolicy.js";
import TermsOfService from "./Components/Legal/TermsOfService.js";
import CookiesPolicy from "./Components/Legal/CookiesPolicy.js";
import AdminUpdatePosts from "./Components/Admin/AdminUpdatePosts.js";
import ShowBookedUsers from "./Components/Post/ShowBookedUsers.js";
import ShowAcceptedUsers from "./Components/Requests/ShowAcceptedUsers.js";
import ContactUs from "./Components/Legal/ContactUs.js";
import Shipping from "./Components/Legal/Shipping.js";
import VideoCreationGuidelinesPage from "./Components/Verification/VideoCreationGuidelinesPage.js";
import SlotBookingPage from "./Components/Verification/SlotBookingPage.js";
import PostingGuidelines from "./Components/Guidelines/PostingGuidelines.js";
import RequestingGuidelines from "./Components/Guidelines/RequestingGuidelines.js";
import MeetingGuidelines from "./Components/Guidelines/MeetingGuidelines.js";
import PaymentsPolicy from "./Components/Legal/PaymentsPolicy.js";
import ReportedPosts from "./Components/Admin/ReportedPosts.js";
import DataAnalytics from "./Components/DataAnalytics/DataAnalytics.js";
import RequestTabDetails from "./Components/Requests/RequestTabDetails.js";
import MyRequestTabDetails from "./Components/Requests/MyRequestTabDetails.js";
import AcceptedRequestTabDetails from "./Components/Requests/AcceptedRequestTabDetails.js";
import RequestUsersList from "./Components/Requests/RequestUsersList.js";
import RequestUserTabDetails from "./Components/Requests/RequestUserTabDetails.js";
import RequestToUsers from "./Components/Requests/RequestToUsers.js";
import RequestToUserTabDetails from "./Components/RequestUser/RequestToUserTabDetails.js";
import RequestFromUserTabDetails from "./Components/RequestUser/RequestFromUserTabDetails.js";
import RequestFromUsers from "./Components/Requests/RequestFromUsers.js";
import RequestUserPayments from "./Components/Payments/RequestUserPayments.js";
import RequestPayments from "./Components/Payments/RequestPayments.js";
import NewsSection from "./Components/News/NewsSection.js";
import Blog from "./Components/News/Blog.js";
import ViewUser from "./Components/User/ViewUser.js";
import PublicViewUser from "./Components/User/PublicViewUser.js";
import OrganizationPage from "./Components/Organizations/OrganizationPage.js";
import AddOrganizationUsers from "./Components/Organizations/AddOrganizationUsers.js";
import ShowOrganizationUsers from "./Components/Organizations/ShowOrganizationUsers.js";
import Analytics from "./Components/Diwakar_dev/DataAnalytics.js";
import OrganizationTabDetails from "./Components/Organizations/OrganizationTabDetails.js";
import UserList from "./Components/SuperAdmin/UserList.js";
import UserFeedbacks from "./Components/User/UserFeedbacks.js";
import TeacherSessions from "./Components/User/TeacherSessions.js";
import UserAnalytics from "./Components/User/UserAnalytics.js";
import Notifications from "./Components/User/Notifications.js";
import MyContent from "./Components/Platform/MyContent.js";
import UserProfileAdminView from "./Components/Admin/UserProfileAdminView.js";
import AdminUpdateRequests from "./Components/Admin/AdminUpateRequests.js";
import BankVerificationForm from "./Components/User/BankVerificationForm.js";
import AdminViewUser from "./Components/Admin/AdminViewUser.js";
import AdminViewAllUsers from "./Components/Admin/AdminViewAllUsers.js";
import AdminViewVerifiedUsers from "./Components/Admin/AdminViewVerifiedUsers.js";
import EmployeeBirthDayCard from "./Components/Team/EmployeeBirthDayCard.js";
import PosterMessage from "./Components/Posters.js/PosterMessage.js";
import JaiHind from "./Components/Posters.js/JaiHind.js";
import OnlineClasses from "./Components/Posters.js/OnlineClasses.js";
import PaymentDetails from "./Components/Platform/PaymentDetails.js";
import CreateRequest1 from "./Components/Requests/CreateRequest1.js";
import { Dashboard, Recommend } from "@mui/icons-material";
import MySessions from "./Components/Platform/MySessions.js";
import Recommended from "./Components/Recommendations/Recommended.js";
import MyRequests from "./Components/Requests/MyRequests.js";
import AcceptedRequests from "./Components/Requests/AcceptedRequests.js";
import UserRefunds from "./Components/User/UserRefunds.js";
import EmployeeDashboard from "./Components/Dashboard/Dashboard.js"
import Vidya from "./Components/AI Systems/Vidya.js";
import AgoraSessionPage from "./Components/Agora/AgoraSessionPage.js";
import OverallSessions from "./Components/AI Systems/OverallSessions.js";
import CreateSeriesForm from "./Components/Post Bundles/CreateSeriesForm.js";
import BundleDetail from "./Components/Post Bundles/BundleDetail.js";
import AddressByPincode from "./Components/PostalAddress/AddressByPincode.js";
import ShareRedirect from "./Components/Share/ShareRedirect.jsx";
import CreateSwitcher from "./Components/Platform/CreateSwitcher.js";
import MyPostBundleDetails from "./Components/Post Bundles/MyPostBundleDetails.js";
import MyBundleBookingDetails from "./Components/Post Bundles/MyBundleBookingDetails.js";
import ShareBundleRedirect from "./Components/Share/ShareBundleRedirect.js";
import BundlePayments from "./Components/Payments/BundlePayments.js";
import PostList from "./Components/Testing1/PostList.js";
import CircularProgress from '@mui/material/CircularProgress';
import AdminAppointments from "./Components/Admin/AdminAppointments.js";
import {
  Typography,
} from "@mui/material";
import ReserveButton from "./Components/UserReservations/ReserveButton.js";
import UserListView from "./Components/Admin/UserListView.js";
import ActivePostBookings from "./Components/DataAnalytics/ActivePostBookings.js";
import ActivePosts from "./Components/Admin/ActivePosts.js";
import ExpertAgreement from "./Components/Expert/ExpertAgreement.js";
import CampusAmbassador from "./Components/Ambassador/CampusAmbassador.js";
import SalesPartnerAgreement from "./Components/SalesPartners/SalesPartnerAgreement.js";
import SalesPartnerAgreementCompany from "./Components/SalesPartners/SalesPartnerAgreementCompany.js";
import ExpertOnboarding from "./Components/Expert/ExpertOnboarding.js";
import AdminExpertRequests from "./Components/Admin/AdminExpertRequests.js";
import AmbassadorOnboarding from "./Components/Ambassador/AmbassadorOnboarding.js";
import AdminAmbassadorRequests from "./Components/Admin/AdminAmbassadorRequests.js";
import SalesPartnerOnboarding from "./Components/SalesPartners/SalesPartnerOnboarding.js";
import AdminSalesPartnerDashboard from "./Components/Admin/AdminSalesPartnerDashboard.js";
import CreateEmployee from "./Components/Admin/CreateEmployee.js";
import UserReservationsTable from "./Components/UserReservations/UserReservationsTable.js";
import ExpertProfilePage from "./Components/Expert/ExpertProfilePage.js";
import MigrateRolesButton from "./Components/Admin/MigrateRolesButton.js";
import AskAnything from "./Components/AskAnything/AskAnything.js";
import SendDiwaliEmailButton from "./Components/Emails/SendDiwaliEmailButton.js";
import PostReviewPanel from "./Components/Admin/PostReviewPanel.js";
// roles: 'sales-executive', 'anthra-sales-executive', 'admin','ambassador','sales-partner-individual','sales-partner-company', 'expert';
import NewsletterSubscriptionsPage from "./Components/Newsletter/NewsLetterSubscriptionsPage.js";
import AdminCreateCoupon from "./Components/Admin/AdminCreateCoupon.js";
import AdminControlCenter from "./Components/Admin/AdminControlCenter.js";
import AskExpert from "./Components/AskAnything/AskExpert.js";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import InvoiceList from "./Components/Invoices/InvoiceList.js";
import InvoiceView from "./Components/Invoices/InvoiceView.js";
import RequestsPage from "./Components/AskAnything/RequestsPage.js";
import MediaMigrationPage from "./Components/Migrations/MediaMigrationPage.js";
import RequestDetailsPage from "./Components/AskAnything/RequestDetailsPage.js";
import Requested from "./Components/Requests/Requested.js";
import MyRequestsList from "./Components/AskAnything/MyRequestsList.js";
import MyRequestsAnalytics from "./Components/AskAnything/MyRequestsAnalytics.js";
import MyRequestsListExpert from "./Components/AskAnything/MyRequestsListExpert.js";
import RequestPaymentsNew from "./Components/Payments/RequestPaymentsNew.js";
import DownloadCenter from "./Components/DownloadCenter/DownloadCenter.js";
import DownloadHistory from "./Components/DownloadCenter/DownloadHistory.js";
import EditRequest from "./Components/AskAnything/EditRequest.js";
import AiTrainingPayments from "./Components/Payments/AiTrainingPayments.js";
import AiProgramPage from "./Components/AI Training Program/AiProgramPage.js";
import AiProgramAdminPage from "./Components/Admin/AiProgramAdminPage.js";
import SchedulePage from "./Components/AI Training Program/SchedulePage.js";
import EditPost from "./Components/Expert Controls/EditPost.js";
import ReschedulePost from "./Components/Expert Controls/ReschedulePost.js";
import ParticipantsPage from "./Components/Expert Controls/ParticipantsPage.js";
import EnterpriseAISolutions from "./Components/Enterprise/EnterpriseAISolutions.js";
import SessionsList from "./Components/Sessions/SessionsList.js";
import SessionSlider from "./Components/Sessions/SessionSlider.js";
import EnterpriseAIAdmin from "./Components/Enterprise/EnterpriseAIAdmin.js";
import SubscriptionPage from "./Components/Subscriptions/SubscriptionPage.js";
import NewSubscriptionPayments from "./Components/Payments/NewSubscriptionPayments.js";
import SessionCheckout from "./Components/Payments/SessionCheckout.js";
import Achievements from "./Components/Achievements.js";
import RequestUserPlatform from "./Components/RequestUser/RequestUserPlatform.js";
import ExpertsPage from "./Components/Expert/ExpertsPage.js";
import AITrainingProgram from "./Components/AI Training Program/AITrainingProgram.js";
import LiveSession from "./Components/LiveSession.js";
import Mindmap from "./Components/Mindmap.js";
import MeetingRoom from "./Components/MeetingRoom.js";
import axios from "axios";
import AttendancePage from "./Components/Post/AttendancePage.js";
import PaymentSuccess from "./Components/Payments/PaymentSuccess.js";
import LinkedinCallback from
"./Components/Login/LinkedinCallback";
import BlogPage from "./Components/Blog.js";
import ArticlePage from "./Components/ArticlePage.js";

function App() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [userId, setUserId] = useState(null);
  const [userData, setUserData] = useState(null);
  const API_URL = process.env.REACT_APP_API_URL;


  const handleLogin = (userId) => {
    setLoggedIn(true);
    setUserId(userId);
    localStorage.setItem('userId', userId); // Save user ID in localStorage
  };


  const handleLogout = () => {
    setLoggedIn(false);
    setUserId(null);
    localStorage.removeItem('userId'); // Clear userId from localStorage
    localStorage.removeItem('authToken'); // Clear token if required
  };


  const handleGoogleLoginSuccess = (response) => {
    const token = response.credential;
    fetch('/api/auth/google/', {
      method: 'POST',
      body: JSON.stringify({ token }),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.user_id) {
          handleLogin(data.user_id); // Log the user in with the ID returned from backend
        }
      })
      .catch((error) => {
        console.error('Google login failed:', error);
      });
  };


  const handleGoogleLoginFailure = (error) => {
    console.error('Google login failed:', error);
  };



  // useEffect(() => {
  //   const savedUserId = localStorage.getItem('user_id');
  //   console.log('save user id', savedUserId)
  //   if (savedUserId) {
  //     setLoggedIn(true);
  //     setUserId(savedUserId);
  //   }
  // }, []);
  useEffect(() => {
  const storedUserId = localStorage.getItem("userId");
  if (storedUserId) {
    setUserId(storedUserId);
    setLoggedIn(true);
  }
}, []);
useEffect(() => {
  if (!userId) return;

  axios
    .get(`${API_URL}/get_user_data/?user_id=${userId}`)
    .then((res) => {
      console.log("USER DATA:", res.data); // debug
      setUserData(res.data);
    })
    .catch((err) => {
      console.error("User fetch error:", err);
    });
}, [userId]);

const { id } = useParams();
  const ProtectedRoute = ({ children, requiredRoles }) => {
  const { loggedIn, role, roles } = useAuth(); // Assuming `roles` is an array like ['admin', 'editor']
  const location = useLocation(); // ✅ always called at top

  if (loggedIn === null) {
    return (
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 2000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backdropFilter: 'blur(3px)',
        }}
      >
        <Box sx={{ textAlign: 'center' }}>
          <CircularProgress
            size={60}
            thickness={6}
            sx={{
              color: 'transparent',
              '& .MuiCircularProgress-circle': {
                stroke: 'url(#better-gradient)',
              },
            }}
          />

          <svg width="0" height="0">
            <defs>
              <linearGradient id="better-gradient" x1="1" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#f30b96ff" />
                <stop offset="50%" stopColor="#221ce0ff" />
                <stop offset="100%" stopColor="#0eacebff" />
              </linearGradient>
            </defs>
          </svg>

          <Typography
            variant="h6"
            sx={{
              mt: 2,
              color: '#fff',
              textShadow: '0 1px 3px rgba(0,0,0,0.7)',
            }}
          >
            Loading Platform...
          </Typography>
        </Box>
      </Box>
    );
  }

  if (!loggedIn) {
  return (
    <Navigate
      to="/login"
      replace
      state={{ from: location }} // Save the attempted route
    />
  );
}

  // if (!loggedIn) {
  //   return <Navigate to="/login" replace />;
  // }

  // Role-based access control
  if (requiredRoles) {
    const allowedRoles = Array.isArray(requiredRoles)
      ? requiredRoles
      : [requiredRoles];

    const userRoles = Array.isArray(roles) && roles.length > 0
      ? roles
      : role
        ? [role]
        : [];

    const hasAccess = allowedRoles.some((r) => userRoles.includes(r));

    if (!hasAccess) {
      return <Navigate to="/home" replace />;
    }
  }

  return children;
};

// export default ProtectedRoute;

  return (
    <BrowserRouter>
    <ScrollToTop />
      <IdProvider>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
        <CssBaseline />
        <Box
          sx={{
            backgroundColor: 'black',
          }}
        >
          <Routes>
            <Route
              path="/login"
              element={
                loggedIn ? (
                  <Navigate to={`/`} />
                  // <Navigate to={`/platform`} />
                ) : (
                  <Login onLogin={handleLogin} />
                )
              }
            />
            <Route
  path="/linkedin/callback"
  element={<LinkedinCallback />}
/>
            <Route path="/payment-success" element={<PaymentSuccess />} />

            {/* <Route path="/" element={<ProtectedRoute><Posted /></ProtectedRoute>} /> */}
            {/* <Route path="/" element={<ProtectedRoute><SessionsList /></ProtectedRoute>} /> */}
            <Route
              path="/platform/explore"
              element={<ProtectedRoute>
                <SessionsList /></ProtectedRoute>
              }
            />
            
            <Route path="/" element={<EnterpriseAISolutions />} />
            <Route path='/experts' element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}><ExpertsPage /> </ProtectedRoute>} />
            <Route path='/new-subscription-payments' element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}><NewSubscriptionPayments /> </ProtectedRoute>} />
            <Route path='/subscription-page' element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}><SubscriptionPage /> </ProtectedRoute>} />
            <Route path="/enterprise-ai-admin" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}><EnterpriseAIAdmin /></ProtectedRoute>} />
            <Route path='/sessions-slider' element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}><SessionSlider /> </ProtectedRoute>} />
            <Route path='/sessions-list' element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}><SessionsList /> </ProtectedRoute>} />
            <Route path='/enterprise-ai-solutions' element={<ProtectedRoute><EnterpriseAISolutions /> </ProtectedRoute>} />
            <Route path="/expert-participants-view/:postId" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive','expert']}><ParticipantsPage /></ProtectedRoute>} />
            <Route path="/expert-reschedule-post/:postId" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive','expert']}><ReschedulePost /></ProtectedRoute>} />
            <Route path="/expert-edit-post/:postId" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive','expert']}><EditPost /></ProtectedRoute>} />
            <Route path='/ai-program-schedule-page' element={<ProtectedRoute><SchedulePage /> </ProtectedRoute>} />
            <Route path="/ai-program-admin-page" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}><AiProgramAdminPage /></ProtectedRoute>} />
            <Route path='/ai-program-page' element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}><AITrainingProgram /> </ProtectedRoute>} />
            <Route path='/ai-training-payments' element={<ProtectedRoute><AiTrainingPayments /> </ProtectedRoute>} />
            <Route path="/edit-request/:id" element={<ProtectedRoute requiredRoles={['admin']}><EditRequest /></ProtectedRoute>} />
            <Route path="/download-history" element={<ProtectedRoute requiredRoles={['admin']}><DownloadHistory /></ProtectedRoute>} />
            <Route path="/download-center" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}><DownloadCenter /></ProtectedRoute>} />
            <Route path='/request-payments-new/:type/:id' element={<ProtectedRoute><RequestPaymentsNew userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />
            <Route path="/my-requests-list-expert" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive','expert']}><MyRequestsListExpert /></ProtectedRoute>} />
            <Route path="/my-requests-analytics" element={<ProtectedRoute requiredRoles={['admin']}><MyRequestsAnalytics /></ProtectedRoute>} />
            <Route path="/my-requests-list" element={<ProtectedRoute ><MyRequestsList /></ProtectedRoute>} />
            <Route path="/requested" element={<ProtectedRoute requiredRoles={['admin']}><Requested /></ProtectedRoute>} />
            <Route path="/request-details-page/:id" element={<ProtectedRoute requiredRoles={['admin', "anthra-sales-executive",]}><RequestDetailsPage /></ProtectedRoute>} />
            <Route path="/media-migration-page" element={<ProtectedRoute requiredRoles={['admin']}><MediaMigrationPage /></ProtectedRoute>} />
            <Route path="/requests-page" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}><RequestsPage /></ProtectedRoute>} />
            <Route path="/invoice-view" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}><InvoiceView /></ProtectedRoute>} />
            <Route path="/invoice-list" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}><InvoiceList /></ProtectedRoute>} />
            
            <Route path="/ask-expert" element={<ProtectedRoute><AskExpert /></ProtectedRoute>} />
           
{/* {/* <Route 
  path="/admin-control-center" 
  element={<AdminControlCenter />} 
/>                         */}
<Route path="/admin-control-center" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}><AdminControlCenter /></ProtectedRoute>} /> 

            <Route path="/admin-create-coupon" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}><AdminCreateCoupon /></ProtectedRoute>} />
            <Route path="/news-letter-subscription-page" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}><NewsletterSubscriptionsPage /></ProtectedRoute>} />
            <Route path="/post-review-panel" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}><PostReviewPanel /></ProtectedRoute>} />
            <Route path="/migrate-roles" element={<ProtectedRoute requiredRoles={['admin']}><MigrateRolesButton /></ProtectedRoute>} />
            <Route path="/send-diwali-email-button" element={<ProtectedRoute requiredRoles={['admin']}><SendDiwaliEmailButton /></ProtectedRoute>} />

            <Route path="/user-list-view" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}><UserListView userId={userId}/></ProtectedRoute>} />
            <Route path="/expert-onboarding" element={<ProtectedRoute ><ExpertOnboarding userId={userId}/></ProtectedRoute>} />
            <Route path="/admin-expert-requests" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}><AdminExpertRequests userId={userId}/></ProtectedRoute>} />
            <Route path="/ambassador-onboarding" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}><AmbassadorOnboarding userId={userId}/></ProtectedRoute>} />
            <Route path="/admin-ambassador-requests" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}><AdminAmbassadorRequests userId={userId}/></ProtectedRoute>} />
            <Route path="/create-member" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}><CreateEmployee userId={userId}/></ProtectedRoute>} />
            <Route path="/user-reservations" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}><UserReservationsTable userId={userId}/></ProtectedRoute>} />
            <Route path="/sales-partner-onboarding" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}><SalesPartnerOnboarding userId={userId}/></ProtectedRoute>} />
            <Route path="/admin-sales-partner-dashboard" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}><AdminSalesPartnerDashboard userId={userId}/></ProtectedRoute>} />

            <Route path="/agora-session" element={<AgoraSessionPage userId={userId}/>} />
            {/* <Route path="/expert-profile" element={<ProtectedRoute ><ExpertProfilePage /></ProtectedRoute>} /> */}
            <Route path="/expert-profile" element={<ExpertProfilePage></ExpertProfilePage>}/>
            <Route path="/ask-anything" element={<AskAnything />} />

            <Route path="/active-posts" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}><ActivePosts userId={userId}/></ProtectedRoute>} />
            <Route path="/expert-agreement" element={<ProtectedRoute><ExpertAgreement userId={userId}/></ProtectedRoute>} />
            <Route path="/campus-ambassador-agreement" element={<ProtectedRoute><CampusAmbassador userId={userId}/></ProtectedRoute>} />
            <Route path="/sales-partner-agreement" element={<ProtectedRoute><SalesPartnerAgreement userId={userId}/></ProtectedRoute>} />
            <Route path="/sales-partner-agreement-company" element={<ProtectedRoute><SalesPartnerAgreementCompany userId={userId}/></ProtectedRoute>} />

            <Route path="/about-us" element={<AboutUs loggedIn={loggedIn} userId={userId} onLogout={handleLogout} />} />
            <Route path="/careers" element={<ProtectedRoute><Careers /></ProtectedRoute>} />
            <Route path="/community" element={<Community />} />
            <Route path="/faqs" element={<Faqs loggedIn={loggedIn} userId={userId} onLogout={handleLogout} />} />

            <Route path="/notifications" element={<Notifications userId={userId} />} />

            <Route path="/expert-payment-details" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive','expert']}><TeacherSessions loggedIn={loggedIn} onLogout={handleLogout} /></ProtectedRoute>} />

            <Route path="/my-content" element={<ProtectedRoute><MyContent loggedIn={loggedIn} userId={userId} onLogout={handleLogout} /></ProtectedRoute>} />

            <Route path="/user-analytics" element={<ProtectedRoute><UserAnalytics loggedIn={loggedIn} userId={userId} onLogout={handleLogout} /></ProtectedRoute>} />

            <Route path="/organization-page" element={<ProtectedRoute><OrganizationPage loggedIn={loggedIn} userId={userId} onLogout={handleLogout} /></ProtectedRoute>} />

            <Route path="/view-user" element={<ProtectedRoute><ViewUser loggedIn={loggedIn} userId={userId} onLogout={handleLogout} /></ProtectedRoute>} />

            <Route path="/active-post-bookings" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}><ActivePostBookings/></ProtectedRoute>} />

            <Route path="/user-refunds" element={<ProtectedRoute><UserRefunds loggedIn={loggedIn} userId={userId} onLogout={handleLogout} /></ProtectedRoute>} />
            
            <Route path="/platform/create-series" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive','expert']}><CreateSeriesForm loggedIn={loggedIn} onLogout={handleLogout} /></ProtectedRoute>} />
            <Route path="/bundle-detail/:id" element={<BundleDetail loggedIn={loggedIn} onLogout={handleLogout} />} />
            <Route path="/reserve-button/:id" element={<ProtectedRoute><ReserveButton/></ProtectedRoute>} />
            <Route path="/my-post-bundle-detail/:id" element={<ProtectedRoute><MyPostBundleDetails /></ProtectedRoute>} />
            <Route path="/my-bundle-booking-detail/:id" element={<ProtectedRoute><MyBundleBookingDetails /></ProtectedRoute>} />
            <Route path="/blog" element={<BlogPage />} />
              <Route
          path="/blogs/:slug"
          element={<ArticlePage />}
        />
            <Route path="/user-feedbacks" element={<ProtectedRoute><UserFeedbacks loggedIn={loggedIn} userId={userId} onLogout={handleLogout} /></ProtectedRoute>} />
            <Route path="/generate-meeting-link" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive','expert']}> <GenerateMeetingLinkButton /> </ProtectedRoute>} />

            <Route path="/user-list" element={<ProtectedRoute requiredRoles={['admin']}><UserList /></ProtectedRoute>} />
            <Route path="/employee-birth-day-card" element={<ProtectedRoute><EmployeeBirthDayCard /></ProtectedRoute>} />
            <Route path="/poster-message" element={<ProtectedRoute><PosterMessage /></ProtectedRoute>} />
            <Route path="/online-classes" element={<ProtectedRoute><OnlineClasses /></ProtectedRoute>} />
            <Route path="/jai-hind" element={<ProtectedRoute><JaiHind /></ProtectedRoute>} />
            <Route path="/post-list" element={<ProtectedRoute requiredRoles={['admin']}><PostList /></ProtectedRoute>} />

            <Route path="/refunds-and-cancellations-policy" element={<RefundsAndCancellationsPolicy userId={userId} loggedIn={loggedIn} onLogout={handleLogout} />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy userId={userId} loggedIn={loggedIn} onLogout={handleLogout} />} />
            <Route path="/terms-of-service" element={<TermsOfService loggedIn={loggedIn} userId={userId} onLogout={handleLogout} />} />
            <Route path="/contact-us" element={<ContactUs loggedIn={loggedIn} userId={userId} onLogout={handleLogout} />} />
            <Route path="/shipping-policy" element={<Shipping loggedIn={loggedIn} userId={userId} onLogout={handleLogout} />} />
            <Route path="/cookies-policy" element={<CookiesPolicy userId={userId} loggedIn={loggedIn} onLogout={handleLogout} />} />
            <Route path="/payments-policy" element={<PaymentsPolicy userId={userId} loggedIn={loggedIn} onLogout={handleLogout} />} />

            <Route path="/news-section" element={<NewsSection userId={userId} loggedIn={loggedIn} onLogout={handleLogout} />} />
            <Route path="/blog/:blogId" element={<Blog />} />

            <Route path="/video-creation-guidelines" element={<VideoCreationGuidelinesPage userId={userId} loggedIn={loggedIn} onLogout={handleLogout} />} />
            <Route path="/posting-guidelines" element={<ProtectedRoute><PostingGuidelines userId={userId} loggedIn={loggedIn} onLogout={handleLogout} /></ProtectedRoute>} />
            <Route path="/requesting-guidelines" element={<ProtectedRoute><RequestingGuidelines userId={userId} loggedIn={loggedIn} onLogout={handleLogout} /></ProtectedRoute>} />
            <Route path="/meeting-guidelines" element={<ProtectedRoute><MeetingGuidelines userId={userId} loggedIn={loggedIn} onLogout={handleLogout} /></ProtectedRoute>} />

            <Route path="/slot-booking-page" element={<ProtectedRoute><SlotBookingPage userId={userId} loggedIn={loggedIn} onLogout={handleLogout} /></ProtectedRoute>} />
            <Route path="/data-analytics" element={<ProtectedRoute><DataAnalytics userId={userId} loggedIn={loggedIn} onLogout={handleLogout} /></ProtectedRoute>} />
            <Route path="/request-users-list" element={<ProtectedRoute><RequestUsersList userId={userId} loggedIn={loggedIn} onLogout={handleLogout} /></ProtectedRoute>} />
            <Route path="/add-organization-users" element={<ProtectedRoute><AddOrganizationUsers userId={userId} loggedIn={loggedIn} onLogout={handleLogout} /></ProtectedRoute>} />
            <Route path="/show-organization-users" element={<ProtectedRoute><ShowOrganizationUsers userId={userId} loggedIn={loggedIn} onLogout={handleLogout} /></ProtectedRoute>} />
            <Route path="/analytics" element={<ProtectedRoute><Analytics userId={userId} loggedIn={loggedIn} onLogout={handleLogout} /></ProtectedRoute>} />

            <Route path="/bank-details" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive','expert', 'ambassador','sales-partner-individual','sales-partner-company']}>  <BankVerificationForm userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />

            <Route path="/vidya" element={<ProtectedRoute requiredRoles="admin"><Vidya loggedIn={loggedIn} userId={userId} onLogout={handleLogout} /></ProtectedRoute>} />
            <Route path="/overall-sessions" element={<ProtectedRoute requiredRoles="admin"><OverallSessions loggedIn={loggedIn} userId={userId} onLogout={handleLogout} /></ProtectedRoute>} />
            <Route path="/address-by-pincode" element={<ProtectedRoute> <AddressByPincode /> </ProtectedRoute>} />

            <Route
  path="/create"
  element={
    <CreateSwitcher
      loggedIn={loggedIn}
      userId={userId}
      handleLogout={handleLogout}
    />
  }
/>



            <Route path="/admin-appointments" element={<AdminAppointments />} />
            <Route path="/signup" element={<SignUp />} />

            <Route path="/customer-support" element={<CustomerSupport loggedIn={loggedIn} userId={userId} onLogout={handleLogout} />} />

            <Route path="/verification" element={<ProtectedRoute> <Verification userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />

            <Route path="/admin-verification" element={<ProtectedRoute requiredRoles="admin"> <AdminVerification userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />
            <Route path="/interviw-panel" element={<ProtectedRoute requiredRoles="admin"> <InterviewPanel userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />
            <Route path="/admin-faqs" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}> <AdminFaqs userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />
            <Route path="/admin-careers" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}> <AdminCareers userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />
            <Route path="/admin-contact-us" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}> <AdminContactUs userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />
            <Route path="/user-payments" element={<ProtectedRoute> <UserPayments userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />
            <Route path="/admin-create-accounts" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive','ambassador','sales-partner-individual','sales-partner-company']}> <AdminCreateAccounts userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />
            <Route path="/admin-update-accounts" element={<ProtectedRoute requiredRoles={['admin']}> <AdminUpdateAccounts userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />
            <Route path="/admin-view-user" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}> <AdminViewUser userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />
            <Route path="/admin-update-posts" element={<ProtectedRoute requiredRoles={['admin']}> <AdminUpdatePosts userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />
            <Route path="/admin-update-requests/:userId" element={<ProtectedRoute requiredRoles={['admin']}> <AdminUpdateRequests userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />
            <Route path="/reported-posts" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}> <ReportedPosts userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />

            <Route path="/data-analytics" element={<ProtectedRoute> <DataAnalytics userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />
            <Route path="/database-size-display" element={<ProtectedRoute requiredRoles={['admin']}> <DatabaseSizeDisplay userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />

            <Route path="/Customer-queries-resolve" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}> <CustomerQueriesResolve userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />
            <Route path="/create-specialized-fields" element={<ProtectedRoute requiredRoles={['admin']}> <CreateSpecializedFields userId={userId} /> </ProtectedRoute>} />
            <Route path="/database-size" element={<ProtectedRoute requiredRoles={['admin']}><DatabaseSizeDisplay /> </ProtectedRoute>} />

            <Route path="/recommendation-setup" element={<ProtectedRoute> <RecommendationSetup userId={userId} /> </ProtectedRoute>} />

            <Route path="/reset-password/:uidb64/:token" element={<PasswordReset />} />


            <Route path="/post-recommendations" element={<ProtectedRoute> <PostRecommendations /> </ProtectedRoute>} />


            <Route
              path="/post/:id"
              element={
                <ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive','expert']}>
                  <CreatePost userId={userId} onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/platform"
              element={
                <ProtectedRoute >
                  <Platform userId={userId} onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/platform/create"
              element={
                   <ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive','expert']}>
                  <CreateRequest1 userId={userId} onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/platform/:userId/"
              element={
                <ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive','expert']}>
                  <CreateRequest1 userId={userId} onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />
            <Route path="/achievements" element={<Achievements />} />
            <Route
              path="/platform/:userId/recommended"
              element={
                <Recommended userId={userId} onLogout={handleLogout} />
              }
            />

            {/* <Route
              path="/platform/explore"
              element={
                <Posted />
              }
            /> */}



            <Route
              path="/platform/bookings"
              element={
                <ProtectedRoute>
                <MyBookings onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/platform/:userId/accepted"
              element={
                <ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive','expert']}>
                <AcceptedRequests userId={userId} onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/platform/my-hosts"
              element={
                <ProtectedRoute>
                <MyPosts onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/platform/:userId/my-requests"
              element={
                <ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive','expert']}>
                <MyRequests userId={userId} onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/platform/:userId/sessions"
              element={
                <ProtectedRoute>
                  <MySessions userId={userId} onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/sub-categories-posts/:id"
              element={
                <ProtectedRoute>
                  <SubCategoriesPosts userId={userId} onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/full-section/:id"
              element={
                <ProtectedRoute>
                  <FullSection userId={userId} onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/post-tab-details/:id"
              element={
                <ProtectedRoute>
                <PostTabDetails onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/organization-tab-details/:orgId"
              element={
                <ProtectedRoute>
                  <OrganizationTabDetails userId={userId} onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/my-post-tab-details/:id"
              element={<ProtectedRoute>
                <MyPostTabDetails userId={userId} onLogout={handleLogout} /></ProtectedRoute>
              }
            />
            <Route
              path="/my-booking-tab-details/:id/:bookingId"
              element={<ProtectedRoute>
                <MyBookingTabDetails userId={userId} onLogout={handleLogout} /></ProtectedRoute>
              }
            />
            <Route
              path="/request-tab-details/:id/:userId"
              element={<ProtectedRoute>
                <RequestTabDetails userId={userId} onLogout={handleLogout} /></ProtectedRoute>
              }
            />
            <Route
              path="/my-request-tab-details/:id/:userId"
              element={<ProtectedRoute>
                <MyRequestTabDetails userId={userId} onLogout={handleLogout} /></ProtectedRoute>
              }
            />
            <Route
              path="/request-to-user-tab-details/:id/:teacher_id"
              element={
                <ProtectedRoute>
                  <RequestToUserTabDetails userId={userId} onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/request-from-user-tab-details/:id/:student_id"
              element={
                <ProtectedRoute>
                  <RequestFromUserTabDetails userId={userId} onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/accepted-request-tab-details/:id/:userId"
              element={<ProtectedRoute>
                <AcceptedRequestTabDetails userId={userId} onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/request-user-tab-details/:id"
              element={
                <ProtectedRoute>
                  <RequestUserTabDetails userId={userId} onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/request-to-users/:id"
              element={
                <ProtectedRoute>
                  <RequestToUsers userId={userId} onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/request-from-users/:id"
              element={
                <ProtectedRoute>
                  <RequestFromUsers userId={userId} onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/UserProfile"
              element={
                <ProtectedRoute>
                <UserProfile userId={userId} onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/public-view-user/:id"
              element={
                <ProtectedRoute>
                  <PublicViewUser userId={userId} onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="/user-profile-admin-view/:id"
              element={
                <ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}>
                  <UserProfileAdminView userId={userId} onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />
             <Route path="/attendance/:postId" element={<AttendancePage />} />
            <Route path='/transactions' element={<ProtectedRoute><PaymentDetails userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />
            <Route path='/payments/:type/:id' element={<ProtectedRoute><Payments userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />
            <Route path='/bundle-payments/:type/:id' element={<ProtectedRoute><BundlePayments userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />
            <Route path='/request-user-payments/:id/:teacher_id' element={<ProtectedRoute><RequestUserPayments userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />
            <Route path='/request-payments/:type/:id/:booking_id' element={<ProtectedRoute><RequestPayments userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />

            <Route path='/subscription-payments/:id' element={<ProtectedRoute> <SubscriptionsPayment userId={userId} onLogout={handleLogout} />  </ProtectedRoute>} />

            <Route path='/subscribe/:id' element={<ProtectedRoute><SubscribeDetails /> </ProtectedRoute>} />
            <Route path="/subscriptions" element={<ProtectedRoute> <Subscriptions userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />

            <Route path="/create-subscriptions" element={<ProtectedRoute requiredRoles={['admin']}> <CreateSubscriptions userId={userId} onLogout={handleLogout} />  </ProtectedRoute>} />
            <Route path="/create-sections" element={<ProtectedRoute requiredRoles="admin"> <CreateSections userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />
            <Route path="/add-subsections" element={<ProtectedRoute requiredRoles="admin"> <AddSubSections userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />
            <Route path="/feedbackform/:id" element={<ProtectedRoute> <FeedbackForm userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />
            <Route path="/guide-feedbackform/:id" element={<ProtectedRoute> <GuideFeedbackForm userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />

            {/* Other Pages */}
            <Route path="/ai-content" element={<ProtectedRoute> <AiContent /> </ProtectedRoute>} />
            <Route path="/category" element={<ProtectedRoute> <Categories userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />
            <Route path="/Documentation" element={<ProtectedRoute> <Documentation userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />
            <Route path="/Demo" element={<ProtectedRoute> <Demo /> </ProtectedRoute>} />
            <Route path="/DataAnalytics" element={<ProtectedRoute> <DataAnalytics /> </ProtectedRoute>} />

            <Route path="/AISync" element={<ProtectedRoute requiredRoles="admin"> <AISync onLogout={handleLogout} /> </ProtectedRoute>} />

            <Route path="/admin-panel" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}>  <AdminPortal userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />
            <Route path="/admin-view-all-users" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}>  <AdminViewAllUsers userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />
            <Route path="/admin-view-verified-users" element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}>  <AdminViewVerifiedUsers userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />

            <Route path="/show-booked-users/:id" element={<ProtectedRoute>  <ShowBookedUsers userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />
            <Route path="/show-accepted-users/:id" element={<ProtectedRoute>  <ShowAcceptedUsers userId={userId} onLogout={handleLogout} /> </ProtectedRoute>} />

            {/* <Route path='/dashboard' element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive','ambassador','sales-partner-individual','sales-partner-company']}><EmployeeDashboard onLogout={handleLogout} /> </ProtectedRoute>} /> */}
                        <Route path='/dashboard' element={<ProtectedRoute requiredRoles={['admin', 'anthra-sales-executive']}><EmployeeDashboard onLogout={handleLogout} /> </ProtectedRoute>} />

            <Route path="/share/post/:id" element={<ShareRedirect />} />
            <Route path="/share/bundle/:id" element={<ShareBundleRedirect />} />
            <Route path="/chatbot" element={<ProtectedRoute><ChatbotUI userId={userId} onLogout={handleLogout} userData={userData || { name: '', surname: '', image: '' }}/></ProtectedRoute>} />
            <Route path="/live/:id" element={<LiveSession />} />
            <Route path="/mindmap/:postId" element={<Mindmap />} />
            <Route path="/session-checkout" element={<SessionCheckout onLogout={handleLogout} />} />
            <Route path="/prejoin" element={<PreJoinScreen onLogout={handleLogout}/>} />
            <Route path="/meeting/:id" element={<MeetingRoom />} />
            <Route path="/prejoin-1v1" element={<PreJoin1v1 />} />

            {/* Default Route */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Box>
        </LocalizationProvider>
      </IdProvider>
    </BrowserRouter>
  );
}

export default App;
